export const firebaseConfig = {
    apiKey: "AIzaSyCtxtG8zqW56uuUy98WzLzW9EXXyzxifTQ",
    authDomain: "logoipsum-d2c69.firebaseapp.com",
    projectId: "logoipsum-d2c69",
    storageBucket: "logoipsum-d2c69.appspot.com",
    messagingSenderId: "735613063911",
    appId: "1:735613063911:web:6ccf63769eb3e963c78842"
};